const trim = (value: string) => (value ? value.trim() : value);
const trimNumber = (value: number) =>
  value ? Number(value.toString().trim()) : value;

const trimDecimals = (value: string) =>
  value ? parseInt(value.trim(), 10) : value;

export default { trim, trimNumber, trimDecimals };
